export const uk = {
    'cant-adjust-phrase':
        'На основании статистики поисковых запросов нет возможности уточнить данную ключевую фразу добавлением минус-слов.',
    'count-views-per-month': 'показов в месяц',
    'load-more': 'Загрузить еще',
    'minus-word-header': 'Минус-слова',
    'minus-word-request-example-header': 'Примеры запросов с минус-словом',
    'phrase-adjustment-info-line-1': 'Чтобы уточнить ключевую фразу, отметьте нужные минус-слова.',
    'phrase-adjustment-info-line-2':
        'Добавление минус-слова к фразе исключает показ объявления по всем запросам, содержащим это слово.',
    'shows-per-mounth': 'Прогноз показов в месяц – {shows}'
};
